import React, { memo, useCallback } from 'react'
import { ImageInnerContainer, BgPictureContainer } from './styles'
import { getImageUrl } from './get-image-url'
import type { Image } from './types'

interface FullScreenImageItemProps {
    image: Image
    overlayIndex: number
    onItemClick: (index: number) => void
}

const FullScreenImageItem: React.FC<FullScreenImageItemProps> = ({ image, overlayIndex, onItemClick }) => {
    const handleClick = useCallback(() => {
        onItemClick(overlayIndex)
    }, [overlayIndex, onItemClick])

    const smallImage = getImageUrl('small-mobile', image)
    const mediumImage = getImageUrl('medium-mobile', image)
    const largeImage = getImageUrl('large-mobile', image)
    const desktopImage = getImageUrl('desktop', image)
    const wideScreenImage = getImageUrl('wide-screen', image)

    return (
        <ImageInnerContainer data-image-id={`full_screen_image_index_${overlayIndex}`} onClick={handleClick}>
            <BgPictureContainer>
                {!!wideScreenImage && <source media="(min-width:1024px)" srcSet={wideScreenImage} />}
                {!!desktopImage && <source media="(min-width:640px)" srcSet={desktopImage} />}
                {!!largeImage && <source media="(min-width:480px)" srcSet={largeImage} />}
                {!!mediumImage && <source media="(min-width:320px)" srcSet={mediumImage} />}
                {!!smallImage && <img loading="lazy" alt={image?.caption} src={smallImage} />}
            </BgPictureContainer>
        </ImageInnerContainer>
    )
}

export default memo(FullScreenImageItem)
